export default __webpack_public_path__ + "static/media/3.808d058f.jpg";